{
  "screen": {
    "sectionHeading": "Datos del paciente",
    "headingCorrect": "Corregir datos del paciente",
    "headingComplete": "Completar datos del paciente",
    "openCorrect": "Corregir datos",
    "openComplete": "Completar datos",
    "explanationCorrect": "Para datos registrados de forma incorrecta. Se aplica al nombre, la fecha de nacimiento y el sexo.",
    "explanationComplete": "Para un paciente identificado después del ingreso. Se aplica al nombre, la fecha de nacimiento y el sexo.",
    "appendOnly": "La versión actual no se elimina. Lo que guarde se convierte en una nueva versión, y ambas permanecen en la historia clínica con el nombre de quien las escribió.",
    "identifierUnchanged": "El reservnummer y el personnummer no se modifican aquí. La pulsera de identificación, las etiquetas y las notas anteriores siguen remitiendo al mismo paciente.",
    "requiredHint": "Los campos sin indicación son obligatorios.",
    "optional": "opcional",
    "saveCorrect": "Guardar la corrección",
    "saveComplete": "Guardar los datos",
    "saving": "Guardando …",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "discardQuestion": "¿Cerrar el formulario? Lo que ha modificado no se guardará.",
    "discardConfirm": "Cerrar sin guardar",
    "discardCancel": "Seguir rellenando",
    "savedOk": "Los datos se han guardado.",
    "openPatient": "Volver al resumen del paciente",
    "estimatedIdentity": "Identidad supuesta, no verificada"
  },
  "fieldHint": {
    "isEstimatedIdentity": "Deje la casilla marcada mientras la identidad sea una suposición. Desmárquela cuando haya verificado quién es el paciente: está documentando su propia valoración, la historia clínica no realiza ninguna comprobación."
  },
  "refusal": {
    "versionStale": "Otra persona ha guardado una nueva versión de los datos del paciente mientras el formulario estaba abierto. Los datos cargados son ahora los más recientes: compruebe lo que ha escrito y guarde de nuevo. Lo que escribió no se ha guardado.",
    "noChange": "No hay cambios respecto a la historia clínica. No se ha creado ninguna versión nueva.",
    "patientNotFound": "El paciente no está en la historia clínica. Los datos no se han guardado.",
    "patientRetracted": "El paciente está retirado (por error) en la historia clínica y no puede recibir una nueva versión. Los datos no se han guardado. Si los datos son necesarios, registre un paciente nuevo.",
    "roleMayNotDocument": "Su rol no permite documentar en la historia clínica. Los datos no se han guardado.",
    "supersedesMissing": "El formulario no sabe de qué versión parte. Cierre el resumen del paciente y vuelva a abrirlo. Los datos no se han guardado.",
    "unknown": "Los datos no se han guardado. Intente de nuevo.",
    "unavailable": "No hay conexión con el servidor. Los datos no se han guardado: deje el formulario abierto e intente de nuevo."
  }
}
